import React, { Fragment } from "react";
import IcTrtmtApplyGray from "../../../../resources/images/icon/trtmtData/card/Icon_trtmt_apply_gray.svg";
import IcDeleteGray from "../../../../resources/images/icon/trtmtData/card/Icon_trtmt_delete_gray.svg";
import IcDeleteActive from "../../../../resources/images/icon/trtmtData/card/Icon_trtmt_delete_on.svg";
import IcDetail from "../../../../resources/images/icon/trtmtData/card/Icon_trtmt_detail.svg";
import IcTrtmtDownOn from "../../../../resources/images/icon/trtmtData/card/Icon_trtmt_down_on.svg";

import { useContext } from "react";
import styled from "styled-components";
import { AppContext } from "../../../../components/AppProvider";
import { openLayerFn } from "../../../Layout";
import {
  SocketCommand,
  socketManager,
} from "./../../../../components/AppProvider";

const ButtonLayer = props => {
  const { setDeleteData, data } = props;
  // type direct, ing, hospital
  // procStat 01 신청 02 신청중 03 완료
  // fileCnt
  // dnCnt
  return (
    <Fragment>
      {/* {props.btnType === "direct" && <ButtonLayerDirect on={props.on} setDeleteData={setDeleteData} data={data} />}
            {props.btnType === "ing" && <ButtonLayerIng on={props.on} setDeleteData={setDeleteData} data={data} />}
            {props.btnType === "hospital" && <ButtonLayerHospital on={props.on} setDeleteData={setDeleteData} data={data} />} */}

      {data.dataType === "U" ? (
        <ButtonLayerDirect
          on={props.on}
          setDeleteData={setDeleteData}
          data={data}
        />
      ) : data.fileCnt > 0 ? (
        <ButtonLayerHospital
          on={props.on}
          setDeleteData={setDeleteData}
          data={data}
        />
      ) : (
        <ButtonLayerDirect
          on={props.on}
          setDeleteData={setDeleteData}
          data={data}
        />
      )}
    </Fragment>
  );
};

const ButtonLayerDirect = props => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const { setDeleteData, data } = props;
  return (
    <ListButtonLayer
      on={props.on}
      onClick={() => {
        setDeleteData(data);
        openLayerFn($(".delete-confirm-layer"));
      }}>
      <Button>
        <Img
          src={IcDeleteGray}
          verticalAlign={"text-top"}
          padding="0px"
          alt=""
        />
        <ButtonText on={props.on}>삭제</ButtonText>
      </Button>
    </ListButtonLayer>
  );
};
const ButtonLayerIng = props => {
  return (
    <ListButtonLayer on={props.on}>
      <Button>
        <ButtonText on={props.on}>처리중입니다</ButtonText>
      </Button>
    </ListButtonLayer>
  );
};
const ButtonLayerHospital = props => {
  const { setDeleteData, data } = props;
  return (
    <ListButtonLayer on={props.on}>
      <LeftButton
        onClick={() => {
          setDeleteData(data);
          openLayerFn($(".delete-confirm-layer"));
        }}>
        <Img
          src={IcDeleteActive}
          verticalAlign={"text-top"}
          padding="0px"
          alt=""
        />
        <ButtonText on={props.on}>삭제</ButtonText>
      </LeftButton>
      {props.data.fileCnt != props.data.dnCnt ? (
        <RightBtnDown data={props.data} on={props.on} />
      ) : (
        <RightBtnView data={props.data} on={props.on} />
      )}
    </ListButtonLayer>
  );
};

const RightBtnDown = props => {
  const { userinfo } = useContext(AppContext);

  // 다운로드 이벤트는 웹소켓 302 사용
  const downloadEvent = () => {
    socketManager(SocketCommand.FILE_UPLOAD, "", {
      type: "download",
      userToken: userinfo.userToken.toString(),
      masterKeys: [
        {
          masterKey1: props.data.refKey.toString(),
          masterKey2: "",
          masterKey3: "",
        },
      ],
      bizType: "PR",
      bizName: "진료자료",
      bizDtlType: "",
      viewYN: "N",
      saveExtYN: "N",
      redirectURL: "",
      colorType: "PP",
      hsptSharYn: "Y",
      bizSubType: "0",
    });
  };

  return (
    <RightButton
      on={props.on}
      onClick={() => {
        downloadEvent();
      }}>
      <Img
        src={IcTrtmtDownOn}
        verticalAlign={"text-top"}
        padding="0px"
        alt=""
      />
      <ButtonText on={props.on}>다운로드 가능</ButtonText>
    </RightButton>
  );
};

const RightBtnView = props => {
  const { userinfo } = useContext(AppContext);

  // 다운로드 이벤트는 웹소켓 302 사용
  const viewEvent = () => {
    socketManager(SocketCommand.FILE_UPLOAD, "", {
      type: "download",
      userToken: userinfo.userToken.toString(),
      masterKeys: [
        {
          masterKey1: props.data.refKey.toString(),
          masterKey2: "",
          masterKey3: "",
        },
      ],
      bizType: "PR",
      bizName: "진료자료",
      bizDtlType: "",
      viewYN: "Y",
      saveExtYN: "N",
      redirectURL: "cnntHspt/1",
      colorType: "PP",
      hsptSharYn: "Y",
      bizSubType: "0",
    });
  };

  return (
    <RightButton
      on={props.on}
      onClick={() => {
        viewEvent();
      }}>
      <Img src={IcDetail} verticalAlign={"text-top"} padding="0px" alt="" />
      <ButtonText on={props.on}>상세보기</ButtonText>
    </RightButton>
  );
};

const RightBtnPurpose = props => {
  const { userinfo } = useContext(AppContext);

  // 다운로드 이벤트는 웹소켓 302 사용
  const goToPay = () => {
    _O.Open("/cmmn/payment/PR/" + props.data.refKey);
  };

  return (
    <RightButton
      on={props.on}
      onClick={() => {
        goToPay();
      }}>
      <Img
        src={IcTrtmtApplyGray}
        verticalAlign={"text-top"}
        padding="0px"
        alt=""
      />
      <ButtonText on={props.on}>신청</ButtonText>
    </RightButton>
  );
};

const ButtonLayerHospitalImsi = props => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const { setDeleteData, data } = props;
  return (
    <ListButtonLayer
      on={props.on}
      onClick={() => {
        setDeleteData(data);
        openLayerFn($(".delete-confirm-layer"));
      }}>
      <Button>
        <Img
          src={IcDeleteActive}
          verticalAlign={"text-top"}
          padding="0px"
          alt=""
        />
        <ButtonText on={props.on}>삭제</ButtonText>
      </Button>
    </ListButtonLayer>
  );
};

const ListButtonLayer = styled.div`
  width: 100%;
  height: 38px;
  line-height: 38px;
`;

const Button = styled.div`
  width: 100%;

  display: inline-block;
  text-align: center;

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  color: #6a62e6;
  box-sizing: border-box;
`;

const ButtonText = styled.div`
  display: inline-block;
  box-sizing: border-box;

  margin-left: 4px;

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;

  color: ${props => (props.on === "true" ? "#6A62E6" : "#A2A2A2")};
`;

const Img = styled.img`
  vertical-align: middle;
  padding-bottom: 3px;
`;

const LeftButton = styled.div`
  width: 50%;

  display: inline-block;
  text-align: center;

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  color: #6a62e6;
  box-sizing: border-box;
`;

const RightButton = styled.div`
  width: 50%;

  display: inline-block;
  text-align: center;

  font-family: "Pretendard";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  color: #6a62e6;
  box-sizing: border-box;

  // border-left:1px solid #6A62E6;
  border-left: 1px solid
    ${props => (props.on === "true" ? "#6A62E6" : "#D9D9D9")};
`;

export default ButtonLayer;
